export enum AnalyticsEventID {
    RequestExam = "RequestExam",
    AchievementGet = "AchievementGet",
    AdShown = "AdShown",
    AdFail = "AdFail",
    AdRequested = "AdRequested",
    CorrectDiagnosis = "CorrectDiagnosis",
    IncorrectDiagnosis = "IncorrectDiagnosis",
    RequestTreatment = "RequestTreatment",
}